<template>
  <div class="neitui-me">
    <c-table
      ref="table"
      :fields="fields"
      :columns="columns"
      url="/neitui/wode2"
      @before-fetch="beforeFetch"
    >
      <email-table-column slot="email" field="jianli_email"></email-table-column>
      <el-table-column slot="jianli_name" label="姓名" class-name="pointer" width="100">
        <template v-slot="{row}">
          <div @click="view(row)">
            <span>{{row.jianli_name}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column slot="zhiwei" label="应聘岗位" width="110">
        <template v-slot="{row}">
          <el-tooltip placement="top">
            <div slot="content">{{row | bumen}}</div>
            <span>{{row.zhiwei_name}}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column slot="status" label="状态" width="220">
        <template v-slot="{row}">
          <span v-html="covertResumeStatus(row)"></span>
        </template>
      </el-table-column>
      <el-table-column slot="caozuo" label="操作" width="70" fixed="right">
        <template v-slot="{row}">
          <el-button type="text" @click="detail(row.jianli_id)">详情</el-button>
        </template>
      </el-table-column>
    </c-table>
  </div>
</template>

<script>
import CTable from '@/components/common/table'
import DepartmentCascade from '@/components/service/department-cascade'
import mixin from '@/mixins'

export default {
  name: 'neitui-me',
  mixins: [mixin],
  components: { CTable },
  data() {
    return {
      fields: [
        {
          prop: 'jianli_status_id',
          placeholder: '状态',
          clearable: true,
          component: 'select',
          options: this.$store.state.global.resume_status_enum
        },
        {
          prop: 'department',
          placeholder: '部门',
          component: DepartmentCascade,
          value: []
        }
      ],
      columns: [
        { slot: 'jianli_name' },
        { prop: 'jianli_mobile', label: '手机', width: 130 },
        { slot: 'email' },
        { prop: 'jianli_xuexiao', label: '学校', 'show-overflow-tooltip': true },
        { prop: 'jianli_xueli', label: '学历' },
        { prop: 'jianli_gender', label: '性别' },
        { prop: 'jianli_age', label: '年龄' },
        { slot: 'zhiwei' },
        { prop: 'jianli_laizi', label: '来源' },
        { slot: 'status' },
        { slot: 'caozuo' }
      ],
      model: null
    }
  },
  methods: {
    beforeFetch(params) {
      [(params.jiagou_first), (params.jiagou_second), (params.jiagou_third), (params.jiagou_forth)] = params.department
      delete params.department
    },
    detail(id) {
      window.open(`/review/${id}`)
    }
  }
}
</script>

<style lang="scss">
</style>
